require('./entry-flow-modal/entry-flow-modal.scss');
var BaseViews = require('../base');
var Button = require('treeline-shared-components/button.js');
var SpinnerButton = require('treeline-shared-components/spinner-button');
var CookiePolicy = require('./entry-flow-modal/content/cookie-policy');
var EntryFlowModal = BaseViews.LayoutView.extend({
    template: require('./entry-flow-modal/entry-flow-modal.html'),
    className: 'fmcy-entry-flow-modal',
    events: {
        'click': 'closeClicked'
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {   
                _appChannel: null,
                id: 'cookie-policy'
            }
        );
    },
    regions : {
      closeButtonRegion: '.fmcy-entry-flow-modal-close-button-region',
      contentRegion: '.fmcy-entry-flow-modal-content-region'
    },
    closeClicked: function() {
        this.trigger('close:clicked');
    },
    _renderCloseButton: function () {
        var self = this;
        var closeButton = new SpinnerButton.SpinnerButton({
            label: '×',
            multiClick: false,
            classNames: 'fmcy-entry-flow-modal-close-btn circle-close-btn',
            theme: SpinnerButton.THEMES.PRIMARY,
            size: SpinnerButton.SIZES.LARGE,
            onClickedCallback: function () {
                self.trigger('close:clicked');
            }
        });
        this.closeButtonRegion.show(closeButton);
    },
    _renderContent: function () {
        var content = new CookiePolicy();
        this.contentRegion.show(content);
    },
    onRender: function () {
        this._renderCloseButton();
        this._renderContent();
    }
});
module.exports = EntryFlowModal;



/** WEBPACK FOOTER **
 ** ./assets/js/common/entry-flow/entry-flow-modal.js
 **/